module.exports = __webpack_public_path__ + "static/img/denglulogo.ca75f25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/denglulogo.png
// module id = yMvk
// module chunks = 1